// Auto-updated by GitHub Actions on each push to main
export const APP_VERSION = '2.42.0'
